import { createApp, ref } from 'vue';
import IntroHelp from './components/IntroHelp.vue';
import { store } from './store.js';
import lang from './lang';


let app = createApp(IntroHelp, { 'show-modal': store.showTutorial });

app.config.globalProperties.$tutorial = ref(false);
app.provide('lang', code => {
	const l = window.localStorage.getItem('user_lang');
	store.lang = l ? l : 'en';
	return lang[store.lang][code];
});

app.mount('#vue-tutorial-mount-point');
